import React from 'react';
import { Controller } from 'react-hook-form';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  formControlLabelClasses,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

// MUI 기본 Checkbox 레이아웃을 유지하면서, 두 상태 모두 CommonCheckbox 와 동일한 svg 아이콘으로 그린다.
const UncheckedIcon = <img src="/images/icons/unchecked.svg" alt="unchecked" />;
const CheckedIcon = <img src="/images/icons/checked.svg" alt="checked" />;

export function RHFCheckbox({ control, row, name, label, options, spacing, helperText, sx, rules, ...other }) {
  const { t } = useTranslation();
  const getSelected = (selectedItems = [], item) =>
    selectedItems.includes(item) ? selectedItems.filter(value => value !== item) : [...selectedItems, item];

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <FormControl component="fieldset" sx={{ m: 0, p: 0, border: 'none', minWidth: 0 }}>
          {label && (
            <FormLabel component="legend" sx={{ typography: 'body2' }}>
              {label}
            </FormLabel>
          )}

          <FormGroup
            sx={{
              ...(row && { flexDirection: 'row' }),
              [`& .${formControlLabelClasses.root}`]: {
                '&:not(:last-of-type)': {
                  mb: spacing || 0,
                },
                ...(row && {
                  mr: 0,
                  '&:not(:last-of-type)': {
                    mr: spacing || 2,
                  },
                }),
              },
              ...sx,
            }}>
            {(options || []).map(option => (
              <FormControlLabel
                key={option.value}
                control={
                  <Checkbox
                    checked={field.value?.includes(option.value)}
                    onChange={() => field.onChange(getSelected(field.value, option.value))}
                    disableRipple
                    icon={UncheckedIcon}
                    checkedIcon={CheckedIcon}
                  />
                }
                label={t(option.label)}
                {...other}
              />
            ))}
          </FormGroup>

          {(!!error || helperText) && (
            <FormHelperText error={!!error} sx={{ mx: 0 }}>
              {error ? error?.message : helperText}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
